import React from 'react';
import { Grid } from '@mui/material';

interface SplitReportContainerProps {
    reports: React.ReactNode[];
}

export const SplitReportContainer = ({
    reports,
}: SplitReportContainerProps) => {
    return (
        <Grid container direction={'row'} justifyContent={'center'} spacing={2}>
            {reports.map((report, idx) => (
                <Grid item key={idx} xs={12} sm={12} md={6} lg={6} xl={6}>
                    {report}
                </Grid>
            ))}
        </Grid>
    );
};
